/**
 * Pill-tab / filter chip switcher.
 * items: [{ value, label, count? }]
 * value: current selected value, onChange(value)
 * testIdPrefix: base for `data-testid="${prefix}-${value}"`
 */
export function NexaChipTabs({ items, value, onChange, testIdPrefix, size = "md" }) {
  const h = size === "sm" ? "h-6 px-2 text-[10px]" : "h-7 px-2.5 text-[10.5px]";
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={testIdPrefix ? `${testIdPrefix}-tabs` : undefined}>
      {items.map((it) => {
        const active = value === it.value;
        return (
          <button
            key={it.value}
            type="button"
            onClick={() => onChange(it.value)}
            data-testid={testIdPrefix ? `${testIdPrefix}-${it.value}` : undefined}
            className={`${h} rounded-full border transition-colors font-medium ${
              active
                ? "bg-nexa-accent text-white border-nexa-ink"
                : "bg-nexa-card text-nexa-mute border-nexa-line hover:text-nexa-ink"
            }`}
          >
            {it.label}
            {typeof it.count === "number" && (
              <span className={`ml-1.5 text-[11px] ${active ? "text-white/70" : "text-nexa-mute-2"}`}>{it.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
